import { promisify } from "util"
import { readFile } from "fs"

const readFilePromisified = promisify(readFile)

export const fileRead = async (file) => {
  const buffer = await readFilePromisified(file)
  return buffer.toString()
}
